import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './basic.style.scss';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <div className="basicLayout__footer">
      <Link to={'/policy/privacy'} target={'_blank'}>
        {t('policy.privacy')}
      </Link>
      <Link to={'/policy/cookie'} target={'_blank'}>
        {t('policy.cookie')}
      </Link>
    </div>
  );
};

export default Footer;
